import { createContext, useContext, useState } from 'react';

export const XflowContext = createContext();

export const XflowProvider = ({ children }) => {
    const [value, setValue] = useState(false);
    const values = {
        value,
        setValue,
    };
    return (
        <XflowContext.Provider value={values}>{children}</XflowContext.Provider>
    );
};

export const useXflowContext = () => useContext(XflowContext);
